/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const FARVER = ['#3b82f6', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b', '#ef4444'];

export default function SagsbehandlerWorkloadPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hent = () =>
      fetch('/api/os/sags-diagnostik/sagsbehandler-workload', { credentials: 'include' })
        .then(r => r.json())
        .then(setData)
        .catch(console.error)
        .finally(() => setLoading(false));
    hent();
    const interval = setInterval(hent, 300000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div style={{ color: '#94a3b8', padding: 32 }}>Henter workload-data...</div>;
  if (!data)   return <div style={{ color: '#ef4444', padding: 32 }}>Fejl ved hentning</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 32, flexWrap: 'wrap' }}>
        {(data.sagsbehandlere || []).map((sb, i) => (
          <div key={sb.id} style={{
            background: '#0f172a', borderRadius: 12, padding: '20px 28px',
            border: `1px solid ${FARVER[i % FARVER.length]}33`, minWidth: 200, flex: 1,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{
                width: 36, height: 36, borderRadius: '50%',
                background: FARVER[i % FARVER.length] + '33',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: FARVER[i % FARVER.length], fontWeight: 700,
              }}>
                {(sb.sagsbehandler || '?').slice(0, 2)}
              </div>
              <span style={{ color: '#e2e8f0', fontWeight: 600 }}>{sb.sagsbehandler}</span>
            </div>
            {[
              { label: 'Aktive sager',        val: sb.aktive_sager,        farve: FARVER[i % FARVER.length] },
              { label: 'Forfalden deadlines', val: sb.forfalden_deadlines, farve: sb.forfalden_deadlines > 0 ? '#ef4444' : '#22c55e' },
              { label: 'Haendelser 7d',       val: sb.haendelser_7d,       farve: '#64748b' },
              { label: 'Gns. sagstid (dage)', val: sb.gns_sagstid_dage,   farve: '#64748b' },
            ].map(k => (
              <div key={k.label} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ color: '#64748b', fontSize: 12 }}>{k.label}</span>
                <span style={{ color: k.farve, fontWeight: 600, fontSize: 14 }}>{k.val ?? 0}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{ height: 220 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data.sagsbehandlere || []}
            margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
          >
            <XAxis dataKey="sagsbehandler" tick={{ fill: '#64748b', fontSize: 12 }} />
            <YAxis tick={{ fill: '#64748b', fontSize: 12 }} />
            <Tooltip
              contentStyle={{ background: '#1e293b', border: 'none', borderRadius: 8, color: '#e2e8f0' }}
            />
            <Bar dataKey="aktive_sager" name="Aktive sager" radius={[4, 4, 0, 0]}>
              {(data.sagsbehandlere || []).map((_, i) => (
                <Cell key={i} fill={FARVER[i % FARVER.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
